module.exports = __webpack_public_path__ + "img/location.ed5fdc02.svg";